<template>
    <v-layout
        row
        wrap
        class="prospective-member__list-item">
        <v-flex
            xs12
            sm4
            md3>
            <v-flex class="prospective-member__list-item__user">
                <v-list two-line>
                    <v-list-tile>
                        <v-list-tile-avatar>
                            <img :src="localWaiverDetails.profileImageUrl" :onerror="imageErrorFallback(localWaiverDetails)" :data-qe-id="`lead_profile_image_${i}`" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title :data-qe-id="`lead_name_${i}`">{{ localWaiverDetails.firstName }} {{ localWaiverDetails.lastName }}</v-list-tile-title>
                            <v-list-tile-sub-title :title="`${localWaiverDetails.chapterName} | ${localWaiverDetails.regionName}`" :data-qe-id="`lead_chaptername_${i}`">{{ localWaiverDetails.chapterName }} | {{localWaiverDetails.regionName}}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-flex>
        </v-flex>
        <v-flex
            class="prospective-member__list-item__view"
            xs12
            sm4
            md3
            text-sm-center>
            <v-flex
                tag="span"
                class="waiver-date"
                :data-qe-id="`prpadmin_waiverdate_${i}`">{{ chapterWaiverConstants.WAIVER_DATE }}
                {{ getFormattedDate(localWaiverDetails.waiverRequestedDate) }}</v-flex>
            <v-flex
                tag="span"
                v-if="!isWaiverVisible(i)"
                :data-qe-id="`prpadmin_more_info_${i}`">{{
                chapterWaiverConstants.MORE_INFO
            }}</v-flex>
            <v-flex
                tag="span"
                v-if="isWaiverVisible(i)"
                :data-qe-id="`prpadmin_less_info_${i}`">{{
                chapterWaiverConstants.LESS_INFO
            }}</v-flex>
            <i class="fas fa-chevron-down" v-if="!isWaiverVisible(i)" @click="toggleWaiver(i, localWaiverDetails.id)" :data-qe-id="`prpadmin_more_info_btn_${i}`"></i>
            <i class="fas fa-chevron-up" v-if="isWaiverVisible(i)" @click="toggleWaiver(i, localWaiverDetails.id)" :data-qe-id="`prpadmin_less_info_btn_${i}`"></i>
        </v-flex>
        <v-flex
            xs12
            sm4
            md3
            class="prospective-member__list-item__actions">
            <v-flex class="status">
                <span class="d-block">
                    {{ chapterWaiverConstants.DENIED }}
                </span>
                <span class="default-cursor" :class="{
                        'custom-tooltip': WaiverVotesCount(localWaiverDetails.waiverVotes, chapterWaiverConstants.DENIED),
                    }">
                    <em class="ypo_red_color" :data-qe-id="`denyCount_${i}`" v-if="showCount(localWaiverDetails)">{{ localWaiverDetails.denyCount }}</em>
                    <PanelMemberToolTip :waiver-votes="WaiverVotes(localWaiverDetails.waiverVotes, chapterWaiverConstants.DENIED)"></PanelMemberToolTip>
                </span>
            </v-flex>
            <v-flex class="status">
                <span class="d-block">
                    {{ chapterWaiverConstants.APPROVED }}
                </span>
                <span class="default-cursor" :class="{
                        'custom-tooltip': WaiverVotesCount(localWaiverDetails.waiverVotes, chapterWaiverConstants.APPROVED),
                    }">
                    <em class="ypo_green_color" :data-qe-id="`approvedCount_${i}`" v-if="showCount(localWaiverDetails)">{{
                        localWaiverDetails.approvedCount
                    }}</em>
                    <PanelMemberToolTip :waiver-votes="WaiverVotes(localWaiverDetails.waiverVotes, chapterWaiverConstants.APPROVED)"></PanelMemberToolTip>
                </span>
            </v-flex>
        </v-flex>
        <v-flex
            xs12
            sm12
            md3
            text-sm-right
            v-if="getExtraButton(localWaiverDetails)">
            <span v-if="getSendOnDate(localWaiverDetails, localWaiverDetails.waiverFlowStatus)" class="prospective-member__list-item__sent-info">
                <em :data-qe-id="`sent_on_date_label_${i}`">{{ chapterWaiverConstants.SENT_ON }} </em>
                <em :data-qe-id="`sent_on_date_${i}`">{{ getSendOnDate(localWaiverDetails, localWaiverDetails.waiverFlowStatus) }}</em>
            </span>
            <span class="check-list">
                <v-btn
                    :disabled ="isPrintForm"
                    @click="sendAction(localWaiverDetails, chapterWaiverConstants.RESEND_TO_REGION, i)"
                    :loading="getUpdateInProgressSecondary(localWaiverDetails.id)"
                    :data-qe-id="`waiver_status_${i}`"
                    class="primary_btn admin-btn">{{chapterWaiverConstants.RESEND_TO_REGION_BUTTON_TEXT}}</v-btn>
            </span>
        </v-flex>
        <v-flex
            xs12
            sm12
            :class="[!getExtraButton(localWaiverDetails) ? 'md3': 'md12']"
            text-sm-right>
            <span v-if="getSendOnDate(localWaiverDetails, localWaiverDetails.waiverFlowStatus) && !getExtraButton(localWaiverDetails)" class="prospective-member__list-item__sent-info">
                <em :data-qe-id="`sent_on_date_label_${i}`">{{ chapterWaiverConstants.SENT_ON }} </em>
                <em :data-qe-id="`sent_on_date_${i}`">{{ getSendOnDate(localWaiverDetails, localWaiverDetails.waiverFlowStatus) }}</em>
            </span>
            <span v-else-if="isFinalized(localWaiverDetails)" class="prospective-member__list-item__sent-info">
                <em :data-qe-id="`waiver_decision_label_${i}`">{{ localWaiverDetails.waiverFlowStatus }} {{chapterWaiverConstants.ON}} </em>
                <em :data-qe-id="`waiver_decision_on_date_${i}`">{{ getFormattedDate(localWaiverDetails.waiverDecisionDate) }}</em>
            </span>
            <span class="check-list" v-if="chapterWaiverConstants.FINALIZE !== localWaiverDetails.waiverFlowStatus">
                <v-btn
                    :disabled ="isPrintForm"
                    @click="sendAction(localWaiverDetails, localWaiverDetails.waiverFlowStatus, i)"
                    :loading="getUpdateInProgress(localWaiverDetails.id)"
                    v-if="getWaiverFlowStatusType(localWaiverDetails.waiverFlowStatus) === chapterWaiverConstants.BUTTON"
                    :data-qe-id="`waiver_status_${i}`"
                    class="primary_btn admin-btn">{{ getWaiverFlowStatus(localWaiverDetails.waiverFlowStatus) }}</v-btn>
                <span v-if="hasSelectedMembers(localWaiverDetails.id)" class="prospective-member__list-item__sent-info check-list__error-info">
                    <em class="error-color mr-2">{{ waiverValidationConstants.PRP_MEMBER_SELECTION_ERROR }}</em>
                </span>
                <PanelMemberList
                    :ref="`waiverDetails-${localWaiverDetails.id}`"
                    v-if="ShowPanelMemberList"
                    :waiver-votes="localWaiverDetails.waiverVotes">
                </PanelMemberList>
            </span>
            <span class="check-list" v-else>
                <v-menu top :close-on-click="closeOnClick">
                    <template v-slot:activator="{ on }"> 
                        <v-btn
                        :disabled ="isPrintForm"
                        @click="sendAction(localWaiverDetails, chapterWaiverConstants.FINALIZE, i)"
                        :loading="getUpdateInProgressSecondary(localWaiverDetails.id)"
                        :data-qe-id="`waiver_status_${i}`"
                        class="primary_btn admin-btn"
                        v-on="on">{{ chapterWaiverConstants.FINALIZE }}</v-btn>
                    </template>
        
                    <v-list class="prospective-member-finalize">
                        <v-list-tile
                            v-for="(status, index) in selectFinalStatus"
                            :key="index"
                            :data-qe-id="`waiver_status_${i}_${index}`"
                            @click="setFinalWaiverStatus(status, localWaiverDetails, i)"
                        >
                            <v-list-tile-title>{{ status }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </span>
            <span class="prospective-member__list-item__send-back" :class="
                    localWaiverDetails.waiverFlowStatus === chapterWaiverConstants.DENIED
                        ? 'ypo_red_color'
                        : 'ypo_green_color'
                " v-if="getWaiverFlowStatusType(localWaiverDetails.waiverFlowStatus) === chapterWaiverConstants.LABEL" :data-qe-id="`waiver_status_${i}`">
                {{ getWaiverFlowStatus(localWaiverDetails.waiverFlowStatus) }}
            </span>
        </v-flex>
        <v-flex
            xs12
            sm12
            md12
            text-sm-right
            v-if="chapterWaiverConstants.RESEND_TO_PRP === localWaiverDetails.waiverFlowStatus">
            <v-menu top :close-on-click="closeOnClick">
                <template v-slot:activator="{ on }"> 
                    <v-btn
                    :disabled ="isPrintForm"
                    @click="sendAction(localWaiverDetails, chapterWaiverConstants.FINALIZE, i)"
                    :loading="getUpdateInProgressSecondary(localWaiverDetails.id)"
                    :data-qe-id="`waiver_status_Finalize_${i}`"
                    class="primary_btn admin-btn prospective-admin-btn"
                    v-on="on">{{ chapterWaiverConstants.FINALIZE }}</v-btn>
                </template>
    
                <v-list class="prospective-member-finalize">
                    <v-list-tile
                        v-for="(status, index) in selectFinalStatus"
                        :key="index"
                        :data-qe-id="`waiver_status_Finalize_${i}_${index}`"
                        @click="setFinalWaiverStatus(status, localWaiverDetails, i)"
                    >
                        <v-list-tile-title>{{ status }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-flex>
        <v-flex
            class="view-wavier active"
            xs12
            v-if="isWaiverVisible(i)">
            <v-flex
                class="prospective-member__loading"
                v-if="getInProgress"
                justify-center
                text-xs-center>
                <v-progress-circular indeterminate color="grey"></v-progress-circular>
            </v-flex>
            <WaiverFormPRPAdmin
                v-else-if="waiverData"
                :prospect="waiverData"
                :isWaiverVisible="isWaiverVisible(i)"
                :sync-request="syncRequest" />
        </v-flex>

        <v-flex>
            <v-dialog
                v-model="showFinalizeDialog"
                scrollable
                persistent
                content-class="small">
                <FinalizeWaiverDialog
                    v-if="showFinalizeDialog"
                    :leadDetails="leadDetails"
                    :close-dialog="hideFinalizeDialog"
                    :waiverFlowStatus="finalWaiverStatus">
                </FinalizeWaiverDialog>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
    import ChapterWaiverBanner from './ChapterWaiverBanner';
    import WaiverFormPRPAdmin from './WaiverFormPRPAdmin';
    import { chapterWaiverConstants, waiverStates, waiverValidationConstants, selectFinalStatus, printForm } from './ChapterWaiver.constants';
    import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
    import { storeGetters } from '../../store/storeGetters.constant';
    import { storeAction } from '../../store/storeActions.constant';
    import { storeMutation } from '../../store/storeMutations.constant';
    import PanelMemberToolTip from './PanelMemberToolTip';
    import { getFormattedDate } from '../../common/utils/dateTime';
    import PanelMemberList from './PanelMemberList';
    import FinalizeWaiverDialog from './FinalizeWaiverDialog';
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import { routerNames } from "../appCommon.constants";

    export default {
        name: 'WaiverTileAdmin',
        components: {
            ChapterWaiverBanner,
            WaiverFormPRPAdmin,
            PanelMemberToolTip,
            PanelMemberList,
            FinalizeWaiverDialog,
            StatusOverlay,
        },
        data: () => {
            return {
                chapterWaiverConstants,
                getInProgress: false,
                waiverStates,
                updateInProgressId: null,
                updateInProgressIdExtraButton: null,
                showErrorForLeadId: null,
                waiverValidationConstants,
                showFinalizeDialog: false,
                leadDetails: null,
                sequence: null,
                finalWaiverStatus: null,
                closeOnClick: true,
                selectFinalStatus, 
                localWaiverDetails: {},
                routerNames,
            };
        },
        created() {
            this.$watch(() => {
                this.localWaiverDetails = this.$props.waiverDetails;
            });
            if (this.isPrintForm) {
                this.localWaiverDetails = this.printWaiverDetails;
            }
        },
        mounted() {
            if (this.isPrintForm) {
                this.toggleWaiver(this.i, this.localWaiverDetails.id);
            }
        },
        methods: {
            printForm,
            getFormattedDate,
            ...mapMutations({
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
            }),
            ...mapActions({
                sendToRegion: `chapterWaiver/${storeAction.sendToRegion}`,
                sendToPRP: `chapterWaiver/${storeAction.sendToPRP}`,
                getFinalizeEmailRecipients: `chapterWaiver/${storeAction.getFinalizeEmailRecipients}`,
                getWaiverDetails: `chapterWaiver/${storeAction.getWaiverDetails}`,
            }),
            getUpdateInProgress(leadId) {
                return this.updateInProgressId === leadId;
            },
            getUpdateInProgressSecondary(leadId) {
                return this.updateInProgressIdExtraButton === leadId;
            },
            toggleWaiver(index, leadId) {
                const viewType = this.chapterWaiverConstants.PRPADMIN;
                const req = {
                    leadId,
                    viewType,
                };
                if (this.communityIdFromRoute) {
                  req.communityId = this.communityIdFromRoute;
                }
                this.getInProgress = true;
                this.getWaiverDetails(req).then(() => {
                    this.getInProgress = false;
                    if (this.isPrintForm) {
                        setTimeout(() => {
                            this.$nextTick(() => {
                                this.showPrint = true;
                                this.printForm(this.localWaiverDetails);
                            });
                        }, 1000);
                    }
                });
                this.sequence = index;
                if (this.isWaiverVisible(index)) {
                    this.setVisibleProspect(null);
                } else {
                    this.setVisibleProspect(index);
                }
            },
            isWaiverVisible(index) {
                return this.visibleProspect === index;
            },
            imageErrorFallback(element) {
                element.profileImageUrl = element.fallbackProfileImageUrl;
                return `this.src='${element.fallbackProfileImageUrl || ''}';this.onerror=null;`;
            },
            getWaiverFlowStatus(waiverFlowStatus) {
                const status = this.waiverStates.filter(state => state.key === waiverFlowStatus);
                return status.length ? status[0].value : '';
            },
            getWaiverFlowStatusType(waiverFlowStatus) {
                const status = this.waiverStates.filter(state => state.key === waiverFlowStatus);
                return status.length ? status[0].type : '';
            },
            async sendAction(waiverDetails, waiverFlowStatus, sequence) {
                let ref = null;
                const req = {};
                let votingPanelIds = [];
                switch (waiverFlowStatus) {
                    case this.chapterWaiverConstants.SEND_TO_REGION:
                        this.updateInProgressId = waiverDetails.id;
                        req.leadId = waiverDetails.id;
                        req.waiverStatus = this.chapterWaiverConstants.REQUESTED;
                        req.waiverFlowStatus = this.chapterWaiverConstants.RESEND_TO_REGION;
                        await this.sendToRegion(req);
                        this.updateInProgressId = null;
                        break;
                    case this.chapterWaiverConstants.RESEND_TO_REGION:
                        req.leadId = waiverDetails.id;
                        req.waiverStatus = this.chapterWaiverConstants.REQUESTED;
                        if (waiverDetails.waiverFlowStatus === this.chapterWaiverConstants.RESENT_TO_REGION_SEND_TO_PRP) {
                            this.updateInProgressIdExtraButton = waiverDetails.id;
                            req.waiverFlowStatus = waiverDetails.waiverFlowStatus;
                        } else {
                            this.updateInProgressId = waiverDetails.id;
                            req.waiverFlowStatus = this.chapterWaiverConstants.RESEND_TO_REGION;
                        }
                        await this.sendToRegion(req);
                        this.updateInProgressId = null;
                        this.updateInProgressIdExtraButton = null;
                        break;
                    case this.chapterWaiverConstants.SEND_TO_PRP:
                    case this.chapterWaiverConstants.RESENT_TO_REGION_SEND_TO_PRP:
                        this.updateInProgressId = waiverDetails.id;
                        ref = this.$refs[`waiverDetails-${waiverDetails.id}`];
                        req.panelMembers = ref.selections;
                        req.leadId = waiverDetails.id;
                        req.isResendToPRP = false;
                        req.waiverStatus = this.chapterWaiverConstants.PENDING;
                        req.waiverFlowStatus = this.chapterWaiverConstants.RESEND_TO_PRP;
                        if (req.panelMembers.length === 0) {
                            this.showErrorForLeadId = waiverDetails.id;
                            this.updateInProgressId = null;
                            setTimeout(() => {
                                this.showErrorForLeadId = null;
                            }, this.chapterWaiverConstants.MAX_TIMEOUT);
                        } else {
                            await this.sendToPRP(req);
                            this.updateInProgressId = null;
                        }
                        break;
                    case this.chapterWaiverConstants.RESEND_TO_PRP:
                        this.updateInProgressId = waiverDetails.id;
                        req.waiverStatus = this.chapterWaiverConstants.PENDING;
                        votingPanelIds = waiverDetails.waiverVotes.map(x => x.panelId);
                        ref = this.$refs[`waiverDetails-${waiverDetails.id}`];
                        req.panelMembers = ref.selections;
                        if (waiverDetails.waiverVotes) {
                            req.panelMembers = req.panelMembers.filter((item) => {
                                return !votingPanelIds.includes(item);
                            });
                        }
                        req.leadId = waiverDetails.id;
                        req.isResendToPRP = true;
                        req.waiverFlowStatus = this.chapterWaiverConstants.RESEND_TO_PRP;
                        await this.sendToPRP(req);
                        this.updateInProgressId = null;
                        break;
                    default:
                        break;
                }
            },
            getSendOnDate(prospectData, waiverFlowStatus) {
                if (
                    waiverFlowStatus.toLowerCase() === this.chapterWaiverConstants.RESEND_TO_PRP.toLowerCase()
                ) {
                    return this.getFormattedDate(prospectData.waiverPostedToPrpdate);
                } else if (
                    waiverFlowStatus.toLowerCase() ===
                    this.chapterWaiverConstants.RESEND_TO_REGION.toLowerCase() || waiverFlowStatus.toLowerCase() ===
                    this.chapterWaiverConstants.RESENT_TO_REGION_SEND_TO_PRP.toLowerCase()
                ) {
                    return this.getFormattedDate(prospectData.waiverSentForCommentsDate);
                } else if (
                    waiverFlowStatus.toLowerCase() === this.chapterWaiverConstants.RESUBMIT.toLowerCase()
                ) {
                    return this.getFormattedDate(prospectData.waiverRequestedDate);
                }
                return null;
            },
            hasSelectedMembers(leadId) {
                return this.showErrorForLeadId === leadId;
            },
            WaiverVotes(waiverVotes, Vote) {
                return waiverVotes && waiverVotes !== [] ?
                    waiverVotes.filter(item => item.voteStatus.toLowerCase() === Vote.toLowerCase()) :
                    null;
            },
            WaiverVotesCount(waiverVotes, Vote) {
                return waiverVotes && waiverVotes !== [] ?
                    waiverVotes.filter(item => item.voteStatus.toLowerCase() === Vote.toLowerCase()).length :
                    null;
            },
            hideFinalizeDialog() {
                this.showFinalizeDialog = false;
                this.updateInProgressId = null;
            },
            syncRequest() {
                this.updateInProgressId = null;
            },
            getExtraButton(waiverDetails) {
                return this.chapterWaiverConstants.RESENT_TO_REGION_SEND_TO_PRP === waiverDetails.waiverFlowStatus;
            },
            showCount(waiverDetails) {
                return waiverDetails.waiverStatus === this.chapterWaiverConstants.PENDING;
            },
            isFinalized(waiverDetails) {
                return waiverDetails.waiverFlowStatus === this.chapterWaiverConstants.APPROVED || waiverDetails.waiverFlowStatus === this.chapterWaiverConstants.DENIED;
            },
            setFinalWaiverStatus(status, waiverDetails, sequence) {
                this.finalWaiverStatus = status === this.chapterWaiverConstants.APPROVE_WAIVER ? this.chapterWaiverConstants.APPROVED : this.chapterWaiverConstants.DENIED;
                this.updateInProgressId = waiverDetails.id;
                this.leadDetails = waiverDetails;
                this.sequence = sequence;
                this.showFinalizeDialog = true;
                this.updateInProgressId = null;
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                visibleProspect: `chapterWaiver/${storeGetters.visibleProspect}`,
                waiverData: `chapterWaiver/${storeGetters.waiverDetails}`,
                printWaiverDetails: `chapterWaiver/${storeGetters.printWaiverDetails}`,
            }),
            ShowPanelMemberList() {
                return (
                    this.localWaiverDetails.waiverFlowStatus.toLowerCase() ===
                    this.chapterWaiverConstants.RESENT_TO_REGION_SEND_TO_PRP.toLowerCase() ||
                    this.localWaiverDetails.waiverFlowStatus.toLowerCase() ===
                    this.chapterWaiverConstants.RESEND_TO_PRP.toLowerCase() || 
                    this.localWaiverDetails.waiverFlowStatus.toLowerCase() ===
                    this.chapterWaiverConstants.SEND_TO_PRP.toLowerCase()
                );
            },
            isPrintForm() {
                return this.$route && this.$route.name === this.routerNames.WAIVER_FORM_PRP_ADMIN;
            },
            communityIdFromRoute() {
              return this.$route.params.communityId;
            },
        },
        props: {
            waiverDetails: {
                type: Object,
                required: false,
            },
            i: {
                type: Number,
                required: false,
            },
        },
    };
</script>

<style lang="scss">
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/responsive.scss';

    .prospective-member-header {
        padding: 10px 10px 10px 0;
        border-bottom: 1px solid $ypo-tile-border;

        h2 {
            border-bottom: 0 !important;
        }

        .search_bar {
            .v-input__slot {
                border-bottom: 1px solid $ypo-tile-border;
                padding-left: 0 !important;

                .v-icon {
                    color: rgba($ypo-blue, 0.5);
                    font-size: 26px;
                }

                .v-label {
                    font-style: italic;
                }
            }
        }

        &__prospect {
            position: relative;

            .result {
                border: 1px solid $ypo-tile-border;
                position: absolute;
                width: 100%;
                background-color: $white;
                z-index: 1;
                border-radius: 3px 0 0 3px;
                max-height: 430px;
                overflow-y: auto;

                .v-list {
                    border-bottom: 1px solid $ypo-tile-border;
                    padding: 0;
                    transition: 0.3s ease all;
                    cursor: pointer;

                    &:last-child {
                        border-bottom: 0;
                    }

                    &:hover {
                        background-color: rgba($ypo-blue, 0.1);
                    }
                }

                .v-list__tile__title {
                    font-weight: bold;
                    color: $ypo-cta;
                }

                .v-list__tile__sub-title {
                    font-weight: 500;
                    color: $ypo-blue !important;
                    font-family: Raleway, serif;
                    font-size: 12px;
                }

                &__spinner {
                    min-height: 80px;
                }

                &__see-all {
                    border-top: 1px solid $ypo-tile-border;

                    .v-list__tile__title {
                        text-align: right;
                    }
                }
            }
        }

        &__sort {
            background-color: $ypo-tile-bgcolor;
            display: flex;
            align-items: center;
            padding: 10px 10px 10px 15px;

            .sort_select {
                font-size: 14px;

                .v-input__slot {
                    background-color: transparent !important;
                    border: 0;
                    padding: 0 !important;

                    .v-select__selection {
                        color: $ypo-cta;
                    }

                    .v-icon {
                        color: $ypo-cta;
                    }
                }
            }

            span {
                min-width: 55px;
            }
        }
    }

    .prospective-member {
        &__success_Message {
            color: $ypo-green;
        }

        &__loading {
            padding: 10px 0px 10px 0px;
            font-size: 15px;
        }

        &__list-item {
            border-bottom: 1px solid $ypo-tile-border;
            align-items: center;
            padding: 10px 15px;

            &__view {
                font-weight: bold;

                span {
                    display: block;
                    color: $ypo-gray-text;
                    font-family: Raleway, serif;
                }

                .waiver-date {
                    color: $ypo-gray-text;
                    font-family: Raleway;
                    font-size: 12px;
                }

                i {
                    color: $ypo-cta;
                    cursor: pointer;
                }
            }

            &__actions {
                .status {
                    display: inline-block;
                    text-align: center;
                    width: 50%;
                    color: $ypo-blue;
                    font-weight: 600;

                    em {
                        display: inline-block;
                        font-style: normal;
                        font-weight: 600;
                        color: $ypo-blue;
                        font-size: 18px;
                    }
                }

                .custom-tooltip {
                    &__info {
                        background: $ypo-tile-bgcolor;
                        box-shadow: 0px 1px 6px 2px rgba($black, 0.2);
                        top: auto;
                        bottom: 40px;
                        max-width: 800px;
                        white-space: nowrap;
                        margin: 0 !important;
                        left: auto;
                        right: -20px;
                        padding: 0px !important;
                        min-width: 100px;

                        &:before,
                        &:after {
                            border-top: 17px solid rgba($black, 0.1);
                            border-left: 10px solid transparent;
                            border-right: 10px solid transparent;
                            border-bottom: 0;
                            bottom: -18px;
                            top: auto;
                            left: auto;
                            right: 15px;
                        }

                        &:after {
                            content: '';
                            position: absolute;
                            border-top: 15px solid $ypo-tile-bgcolor;
                            bottom: -15px;
                        }

                        .info-list {
                            display: inline-block;
                            margin: 10px;
                            text-align: center;
                            min-width: 80px;

                            img {
                                width: 50px;
                                height: 50px;
                                border-radius: 50%;
                                border: 3px $ypo-tile-border solid;
                            }

                            span {
                                color: $ypo-dark-background-gray;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;
                                font-size: 12px;
                                font-weight: 500;
                                display: block;
                                max-width: 80px;
                            }
                        }
                    }
                }
            }

            .success-text {
                color: $ypo-green;
            }

            .failure-text {
                color: $ypo-red;
            }

            &__sent-info {
                display: inline-block;
                vertical-align: middle;
                font-size: 12px;

                em {
                    display: block;
                }

                &.check-list {
                    &__error-info {
                        display: block;
                    }
                }
            }

            &__save-info {
                display: inline-block;
                font-size: 12px;
                width: 160px;
                color: $ypo-green;
            }

            &__sent-status {
                min-width: 168px;
                display: inline-block;
            }

            .admin-btn {
                min-width: 150px;
                font-size: 12px;
                padding: 10px 0;
            }

            .check-list {
                position: relative;

                &__cont {
                    opacity: 0;
                    background: $ypo-extra-light-gray;
                    box-shadow: 0px 1px 6px 1px rgba($black, 0.2);
                    position: absolute;
                    min-width: 200px;
                    top: -10px;
                    max-width: 200px;
                    border-radius: 3px;
                    padding: 10px;
                    visibility: hidden;
                    z-index: 1;
                    left: 0px;
                    transition: 0.3s all ease-in;
                    margin-left: -200px;

                    &:before,
                    &:after {
                        content: '';
                        position: absolute;
                        width: 0;
                        height: 0;
                        border-top: 11px solid transparent;
                        border-bottom: 11px solid transparent;
                        border-left: 16px solid rgba($black, 0.15);
                        right: -17px;
                        top: 14px;
                    }

                    &:after {
                        border-top: 10px solid transparent;
                        border-bottom: 10px solid transparent;
                        border-left: 15px solid $ypo-extra-light-gray;
                        right: -15px;
                        top: 15px;
                    }

                    .v-input--checkbox {
                        margin-bottom: 5px;
                        margin-top: 0;
                        padding: 0;
                    }

                    .v-label {
                        font-size: 12px;
                        font-weight: 500;
                        display: block;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }

                    .v-icon {
                        color: $ypo-cta;
                        font-size: 18px;
                    }

                    .v-input__control {
                        width: 100%;
                    }

                    .v-input--selection-controls__input {
                        margin-right: 0;
                    }

                    &__select-all {
                        .v-label {
                            font-style: italic;
                            font-weight: 600;
                            padding-right: 10px;
                        }
                    }
                }

                &:hover {
                    .check-list__cont {
                        opacity: 1;
                        visibility: visible;
                    }
                }
            }

            &__send-back {
                display: inline-flex;
                min-width: 166px;
                padding-left: 25px;
            }
        }

        .view-wavier {
            background-color: rgba($ypo-blue-grey, 0.3);
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 rgba($black, 0.2);
            border: 1px solid rgba($ypo-blue-grey, 0.8);
            opacity: 0;
            overflow: hidden;
            height: 0;
            transition: all 0.5s;

            &.active {
                height: auto;
                opacity: 1;
            }

            h1 {
                text-align: center;
                font-weight: 500;
                font-family: Raleway, serif;
                font-size: 22px;
                padding-left: 0;
                color: $ypo-blue;
                margin-bottom: 12px;

                span {
                    color: $ypo-red;
                }
            }

            h2 {
                padding-left: 0;
                border-bottom: 0;
                margin-bottom: 12px;
            }

            .form-control {
                span {
                    color: $ypo-cta;
                    display: block;
                }

                small {
                    color: $ypo-cta;
                    font-size: 12px;
                }

                em {
                    font-size: 12px;
                }

                .error-color {
                    color: $ypo-error-red;
                    font-weight: bold;
                }

                .char-count {
                    text-align: right;
                    font-size: 12px;
                }
            }

            .attach-documents {
                .card__file-upload {
                    color: $ypo-cta;
                    font-size: 14px;
                    text-align: center;
                    padding: 8px 15px;
                    border: 1px $ypo-cta dashed;
                    font-weight: 500;
                    cursor: pointer;
                    display: inline-block;
                    transition: 0.3s all ease;
                    margin-top: 15px;

                    &:hover {
                        background-color: $ypo-cta;
                        color: $white;
                    }

                    i {
                        margin-right: 10px;
                    }
                }

                .attachment-error {
                    padding-top: 10px;
                    display: inline-block;
                }

                &__file-upload-spinner {
                    margin: 16px 0 0 20px;
                }
            }
        }
    }

    .prospective-member {
        &__status {
            display: inline-block;
            min-width: 160px;
            text-align: center;
        }

        &__list-item {
            &__user {
                .theme--light.v-list {
                    background: transparent;
                }

                .v-list__tile {
                    padding: 0;
                    height: auto;
                }

                .v-list__tile__title {
                    font-weight: bold;
                    color: $ypo-cta;

                    i {
                        color: $ypo-green;
                        padding-left: 10px;
                    }
                }

                .v-list__tile__sub-title {
                    font-weight: 500;
                    color: $ypo-blue !important;
                    font-family: Raleway, serif;
                    font-size: 12px;
                }
            }
        }

        .view-wavier {
            .form-control {
                .v-input {
                    margin-top: 10px;
                }

                .v-input__control {
                    min-height: inherit;
                }

                .v-input__slot {
                    background: transparent !important;
                    box-shadow: none !important;
                    padding-left: 0 !important;

                    &:before {
                        border-color: rgba($black, 0.2);
                    }
                }


                .v-select__slot {
                    input {
                        border-bottom: 0;
                    }
                }

                .v-label,
                input {
                    font-size: 14px;
                    font-weight: bold;
                    color: $ypo-gray-text !important;
                }

                .v-textarea {
                    .v-input__slot {
                        border: 1px solid rgba($black, 0.2);
                        padding-left: 10px !important;
                        border-radius: 4px;
                    }
                }

                &.link {

                    .v-label,
                    input {
                        color: $ypo-cta !important;
                    }
                }

                .v-menu__content {
                    box-shadow: 0 2px 5px 0 rgba($black, 0.18);
                    border: 1.5px solid rgba($ypo-text-border, 0.25);
                    border-radius: 3px;
                    min-height: 307px;

                    .v-list {
                        background: $ypo-extra-light-gray;

                        &>div {
                            &:hover {
                                background: $ypo-cta;

                                .v-list__tile__title {
                                    color: $white;
                                }
                            }

                            .v-list__tile__title {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
        }
    }

    .waiver-block {
        @include breakpoint(sm) {
            .prospective-member {
                &__list-item {
                    &__sent-info {
                        &.check-list {
                            &__error-info {
                                padding-left: inherit;
                                text-align: inherit;
                            }
                        }
                    }
                }
            }
        }

        @include breakpoint(xs) {
            margin: 15px 10px !important;
            padding-bottom: 50px;

            .prospective-member {
                &__list-item {
                    border: 1px solid $ypo-tile-border;
                    margin: 10px;
                    border-radius: 3px;
                    background: rgba($ypo-tile-border, 0.15);

                    &__view {
                        border-top: 1px dashed $ypo-medium-gray;
                        border-bottom: 1px dashed $ypo-medium-gray;
                        padding: 10px 0 10px 56px;
                        margin: 5px 0;
                        display: inherit;

                        i {
                            margin-top: 2px;
                            font-size: 14px;
                            padding: 0px 10px;
                        }

                        span {
                            font-size: 12px;
                            flex: initial;
                            display: inherit;
                        }

                        .waiver-date {
                            margin-right: 15px;
                        }
                    }

                    &__sent-info,
                    &__status {
                        padding-left: 56px;
                        display: block;
                    }

                    &__actions {
                        padding: 5px 0px 5px 56px;
                        border-bottom: 1px dashed $ypo-medium-gray;
                        margin-bottom: 5px;

                        .custom-tooltip__info {
                            max-width: inherit;

                            &__details {
                                max-width: 260px;
                                overflow: auto;
                            }
                        }

                        .deny {
                            .custom-tooltip__info {
                                right: inherit;
                                left: -20px;

                                &:before,
                                &:after {
                                    left: 15px;
                                    right: inherit;
                                }

                                &:after {
                                    left: 9px;
                                }
                            }
                        }

                        .status {
                            width: auto;
                            margin-right: 20px;
                        }
                    }

                    &__send-back {
                        min-width: inherit;
                        padding-left: 53px;
                    }

                    &__btns {
                        padding-left: 30px;

                        p {
                            padding-left: 25px;
                            margin-bottom: 0px;
                        }
                    }

                    &__comment_btn {
                        padding-left: 50px;
                    }

                    .check-list__cont {
                        left: 0;
                        margin-left: 0;
                        top: 35px;

                        &:before,
                        &:after {
                            display: none;
                        }
                    }
                    .check-list {
                        padding-left: 50px;
                    }
                }

                .view-wavier {
                    &__block {
                        padding: 10px !important;

                        h1,
                        h2 {
                            font-size: 16px;
                            line-height: normal;
                        }
                    }
                }

                &-header {
                    &__sort {
                        margin: 0px 15px;

                        &__block {
                            padding-right: 0px !important;
                        }
                    }

                    &__prospect {
                        margin: 5px 15px;
                    }
                }

                .check-list {
                    &__error-info {
                        padding-left: 10px;
                        top: -5px;
                        text-align: center;
                    }
                }
            .prospective-admin-btn {
                margin: 20px 0 0 57px;
            }    
            }
        }
    }
    .prospective-member-finalize {
        v-list-tile {
            display: block;
            padding: 10px;
            cursor: pointer;
            &:hover {
                background-color: rgba($ypo-gray, 0.1);
            }
        }
    }
</style>
